module.exports = __webpack_public_path__ + "img/approval8.9d08c99f.png";